import {configureStore} from '@reduxjs/toolkit';
import machineListReducer from "../features/machine-search/machineSearchSlice";
import claimListReducer from '../features/claim-search/claimSearchSlice'
import productConfigReducer from "../features/product-config/productConfigSlice";
import customersReducer from "../features/customer-search/customersSlice";
import pipSearchReducer from "../features/pip-search/pipSearchSlice";
import warrantySearchReducer from "../features/warranty-search/warrantySearchSlice";
import referenceReducer from "../features/customer-search/referenceSlice";
import customerHistory from "../features/customer-search/customerHistorySlice";
import dealerReducer from "../features/dealer-search/DealerSlice";
import regionalDetailsReducer from "../features/dealer-search/regionalDetailsSlice";
import expirationReportReducer from "../features/expiration-report/expirationReportSlice";
import languageReducer from "../features/Translation/translationSerachSlice";

const reducer = {
    /*counter: counterReducer,*/
    machineSearchResult: machineListReducer,
    customerHistory: customerHistory,
    claims: claimListReducer,
    productConfig: productConfigReducer,
    customers: customersReducer,
    pipList: pipSearchReducer,
    warrantyList: warrantySearchReducer,
    references: referenceReducer,
    dealerResponse: dealerReducer,
    regionalDetails: regionalDetailsReducer,
    expirationReportResponse: expirationReportReducer,
    languageResponse:languageReducer,
}
const store = configureStore({
    reducer,
    devTools: process.env.NODE_ENV !== 'production'
});

export default store;